import script from "./DatasetManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetManager.vue?vue&type=script&setup=true&lang=js"

import "./DatasetManager.vue?vue&type=style&index=0&id=20a32704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a32704"]])

export default __exports__